// extracted by mini-css-extract-plugin
export default {"myAccount":"MyAccount_myAccount__7zd7f","content":"MyAccount_content__kAm5g","backLink":"MyAccount_backLink__94ZaH"};